import React, { useState } from 'react';
import { Container, TextField, Button, Typography, Box, InputAdornment, IconButton } from '@mui/material';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { Background, RegisterForm } from '../../common/Flex/Flex';
import { Link, useNavigate } from 'react-router-dom';
import { loginUser } from './auth.service';
import { Visibility, VisibilityOff } from '@mui/icons-material';
// import { showErrorToast, showSuccessToast } from '../../common/util/util';
import { ToastContainer } from 'react-toastify';

// Validation Schema
const validationSchema = yup.object({
    email: yup
        .string()
        .email('Enter a valid email')
        .required('Email is required'),
    password: yup
        .string()
        .min(6, 'Password should be at least 6 characters long')
        .required('Password is required'),
});

const Login = () => {
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();
    const handleTogglePassword = () => {
        setShowPassword((prev) => !prev);
    };
    const formik = useFormik({
        initialValues: {
            email: '',
            password: '',
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            loginUser(values).then((res: any) => {
                // showSuccessToast(res.message);
                sessionStorage.setItem('user', JSON.stringify(res.user));
                navigate('/');
            }).catch((err) => console.error(err));
        },
    });

    return (
        <Background>
            <Container maxWidth="md">
                <Box sx={{ mt: 5 }}>
                    <Typography variant="h4" sx={{ textAlign: 'center', fontWeight: '600' }} gutterBottom color='white'>
                        Login
                    </Typography>
                    <form onSubmit={formik.handleSubmit}>
                        <RegisterForm elevation={3}>
                            <TextField
                                fullWidth
                                id="email"
                                name="email"
                                placeholder="Email"
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                error={formik.touched.email && Boolean(formik.errors.email)}
                                helperText={formik.touched.email && formik.errors.email}
                            />
                        </RegisterForm>
                        <RegisterForm elevation={3}>
                            <TextField
                                placeholder="Password"
                                // sx={{ mb: 2 }}
                                variant="outlined"
                                name='password'
                                type={showPassword ? "text" : "password"}
                                fullWidth
                                value={formik.values.password}
                                onChange={formik.handleChange}
                                error={formik.touched.password && Boolean(formik.errors.password)}
                                helperText={formik.touched.password && formik.errors.password}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={handleTogglePassword} edge="end">
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </RegisterForm>
                        <RegisterForm elevation={3}>
                            <Button color="success" sx={{
                                background: 'linear-gradient(to right, #10374A, #1e6283)',
                                color: 'white',
                                '&:hover': {
                                    background: 'linear-gradient(to right, #1e6283, #10374A)',
                                }, fontWeight: '500'
                            }} variant="contained" fullWidth type="submit">
                                Login
                            </Button>
                        </RegisterForm>
                    </form>
                    <Typography margin={2} sx={{ color: 'linear-gradient(to right, #10374A, #1e6283)' }} textAlign={'center'}>
                        Don't have an account? <Box component={Link} sx={{ fontWeight: '600', color: 'white', textDecoration: 'none' }} to={'/auth/register'}>SignUp</Box>
                    </Typography>
                </Box>
            </Container>
            <ToastContainer position="top-right" autoClose={3000} />
        </Background>
    );
};

export default Login;
